import React = require('react');
import { Button, Col, Modal, Row } from 'react-bootstrap';
import * as Commonmark from 'react-commonmark';
import { IProduct } from '../../../../../../../data/api/models';
import { get } from 'lodash';
import { FaInfoCircle } from 'react-icons/fa';

interface IMedicalInfoModalProps {
  showDeclineModal: boolean,
  onCloseModal: () => any,
  product: IProduct
}

export const MedicalInfoModal = ({ showDeclineModal, onCloseModal, product }: IMedicalInfoModalProps) => {
  return (
    <Modal show={showDeclineModal} onHide={onCloseModal} keyboard={false} backdrop={'static'}>
      <Modal.Header closeButton={true}>
        <Modal.Title><FaInfoCircle className="info-btn"/> About your medical history</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            We have some questions about your medical history including questions about your mental health.
          </Col>
          <Col xs={12}>
            <div>
              <Commonmark source={get(product, 'metadata.definitions.medical_conditions')} linkTarget="_blank"/>
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row>
          <Col xs={6}/>
          <Col xs={6}>
            <Button block={true} className={'admiral-white-btn'} onClick={onCloseModal}>
              CLOSE
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}
